import { AlertState, NewAlert } from '../interfaces/alert';

const initialAlerts: AlertState = {};

export const initialAlertsNew: NewAlert[] = [];

export default initialAlerts;
